import { Injectable, EventEmitter } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { BaseComponent } from '../models/components/BaseComponent';
import { BaseDimensionComponent } from '../models/components/commonComponents/BaseDimensionComponent';
import { SeatComponent } from '../models/components/objectComponents/SeatComponent';
import { LayerComponent } from '../models/components/commonComponents/LayerComponent';
import { CollisionBehaviourComponent } from '../models/components/commonComponents/CollisionBehaviorComponent';
import { DockingBehaviourComponent } from '../models/components/commonComponents/DockingBehaviourComponent';
import { NamingComponent } from '../models/components/commonComponents/NamingComponent';
import { Box } from '../models/other/box.model';
import { RackComponent } from '../models/components/objectComponents/RackComponent';
import { Shelf } from '../models/other/shelf.model';
import { PodestComponent } from '../models/components/commonComponents/PodestComponent';
import { TableComponent } from '../models/components/objectComponents/TableComponent';
import { OverheadStorageComponent } from '../models/components/objectComponents/OverheadStorageComponent';
import { PlacingRestrictorComponent } from '../models/components/commonComponents/PlacingRestrictorComponent';
import { NonUsableSpaceComponent } from '../models/components/objectComponents/NonUsableSpaceComponent';
import { WallComponent } from '../models/components/objectComponents/WallComponent';
import { IValidationService } from '../models/interfaces/iValidationService.interface';

@Injectable({providedIn:'root'})
export class ComponentService {
    private currentComponentsBehavior: BehaviorSubject<Array<BaseComponent>> = new BehaviorSubject(null);
    public componentsChanged: EventEmitter<any> = new EventEmitter();
    private validationService:IValidationService;

  getCurrentComponentsObservable(): Observable<Array<BaseComponent>> {
    return this.currentComponentsBehavior.asObservable();
  }

  getCurrentComponents(): Array<BaseComponent> {
    return this.currentComponentsBehavior.value;
  }

  setCurrentComponents(val: Array<BaseComponent>): void {
    this.currentComponentsBehavior.next(val);
  }

  getValidationService(): IValidationService {
    return this.validationService;
  }

  setValidationService(validationService:IValidationService){
    this.validationService = validationService;
  }

  mockComponents(){
    //this.seatMock();
    this.rackMock();
    //this.tableMock();
    //this.overHeadStorageMock();
    //this.doorMock();
    //this.nonUsableSpaceMock();
    //this.wallMock();
  }
  wallMock() {
    let carr = new Array<BaseComponent>();
    let bdc = new BaseDimensionComponent(); 
    bdc.box = new Box();
    bdc.box.SetSize(10,1500,2000);
    let lc = new LayerComponent();
    let nusc = new WallComponent();
    let nc = new NamingComponent();
    carr.push(bdc);
    carr.push(lc);
    carr.push(nusc);
    carr.push(nc);
    this.setCurrentComponents(carr);
  }
  nonUsableSpaceMock() {
    let carr = new Array<BaseComponent>();
    let bdc = new BaseDimensionComponent(); 
    bdc.box = new Box();
    bdc.box.SetSize(1000,1500,1000);
    let lc = new LayerComponent();
    let nusc = new NonUsableSpaceComponent();
    let nc = new NamingComponent();
    carr.push(bdc);
    carr.push(lc);
    carr.push(nusc);
    carr.push(nc);
    this.setCurrentComponents(carr);
  }

  doorMock(){
    // let carr = new Array<BaseComponent>();
    // let bdc = new BaseDimensionComponent(); 
    // bdc.box = new Box();
    // bdc.box.SetSize(100,1500,1000);
    // let lc = new LayerComponent();
    // let dc = new DoorComponent();
    // dc.actualUsableWidth = 1500;
    // dc.depthWithSteps = 0;
    // dc.physicalSplitElement = false;
    // dc.stepAmount = 0;
    // dc.gapBridge = true;
    // dc.doorOpeningType = 1;
    // dc.doorWingType = 2;
    // let prc = new PlacingRestrictorComponent();
    // let nc = new NamingComponent();
    // carr.push(bdc);
    // carr.push(lc);
    // carr.push(dc);
    // carr.push(prc);
    // carr.push(nc);
    // this.setCurrentComponents(carr);
  }

  overHeadStorageMock(){
    let carr = new Array<BaseComponent>();
    let bdc = new BaseDimensionComponent(); 
    bdc.box = new Box();
    bdc.box.SetSize(1000,150,50);
    let pc = new PodestComponent();
    pc.height = 0;
    let lc = new LayerComponent();
    let osc = new OverheadStorageComponent();
    let prc = new PlacingRestrictorComponent();
    let nc = new NamingComponent();
    carr.push(bdc);
    carr.push(pc);
    carr.push(lc);
    carr.push(osc);
    carr.push(prc);
    carr.push(nc);
    this.setCurrentComponents(carr);
  }

  tableMock(){
    let carr = new Array<BaseComponent>();
    let bdc = new BaseDimensionComponent(); 
    bdc.box = new Box();
    bdc.box.SetSize(100,150,50);
    let lc = new LayerComponent();
    let tc = new TableComponent();
    tc.socketAmount = 1;
    tc.tableLeg = false;
    tc.pullOutElement = true;
    tc.foldingElement = false;
    let nc = new NamingComponent();
    carr.push(bdc);
    carr.push(lc);
    carr.push(tc);
    carr.push(nc);
    this.setCurrentComponents(carr);
  }

  seatMock(){
    let carr = new Array<BaseComponent>();
    let bdc = new BaseDimensionComponent(); 
    bdc.box = new Box();
    bdc.box.SetSize(100,150,50);
    let lc = new LayerComponent();
    let sc = new SeatComponent();
    let cbc = new CollisionBehaviourComponent();
    let dbc = new DockingBehaviourComponent();
    let nc = new NamingComponent();
    nc.name = 'Seat';
    carr.push(bdc);
    carr.push(lc);
    carr.push(sc);
    carr.push(cbc);
    carr.push(dbc);
    carr.push(nc);
    this.setCurrentComponents(carr);
  }

  rackMock(){
    let carr = new Array<BaseComponent>();
    let bdc = new BaseDimensionComponent(); 
    bdc.box = new Box();
    bdc.box.SetSize(300,1500,1000);
    let lc = new LayerComponent();
    let rc = new RackComponent();
    rc.shelves = new Array<Array<Shelf>>();
    let arr1 = new Array<Shelf>();
    let arr2 = new Array<Shelf>();
    rc.shelves.push(arr1);
    rc.shelves.push(arr2);
    rc.seperator = true;
    rc.security = 1;
    rc.floorThickness = 0;
    rc.wallThickness = 0;
    rc.seperatorThickness = 0;
    let pc = new PodestComponent();
    pc.height = 0;
    let cbc = new CollisionBehaviourComponent();
    let nc = new NamingComponent();
    nc.name = 'Simple Rack';
    carr.push(bdc);
    carr.push(lc);
    carr.push(rc);
    carr.push(pc);
    carr.push(cbc);
    carr.push(nc);
    this.setCurrentComponents(carr);
  }
}